<template>
  <div>
    <hg-dialog :title="dType[dialogType]" :width="800" :height="340" :visible="dialogVisible" @close="handleClose">
      <div v-loading="loading">
        <my-content ref="ref" :rule-form.sync="formData" :dialog-type="dialogType" />
      </div>
      <div slot="footer" style="width:100%;text-align: right">
        <el-button size="small" icon="el-hg-icon-save" type="primary" v-if="dialogType!=='detail'" @click="submit">保 存</el-button>
        <el-button size="small" icon="el-hg-icon-edit" type="primary" v-if="dialogType === 'detail'" plain @click="$emit('update:dialogType', 'update')">修 改</el-button>
        <el-button size="small" icon="el-hg-icon-close" type="danger" @click="handleClose">关 闭</el-button>
      </div>
    </hg-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HgDialog from '@/components/dialog';
import MyContent from './content';

// const
export default {
  name: 'MyDialog',
  inject: ['$datePipe'],
  components: {
    MyContent,
    HgDialog
  },
  props: {
    id: { type: String },
    dialogType: { type: String },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      dType: {
        insert: '定时任务新增',
        update: '定时任务修改',
        detail: '定时任务详情'
      },
      originData: {},
      formData: {
        taskName: '',
        taskType: 'system',
        state: '-1',
        runClass: '',
        taskTimer: '',
        remark: '',
        createDate: '',
        userName: '',
        depName: '',
        depCode: ''
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor'
    })
  },
  methods: {
    async saveFn(param) {
      let params = JSON.parse(JSON.stringify(param));
      params.updateFlg = this.id ? 'update' : 'add';
      const { status } = await this.$services.postJson({
        type: 'TIMEWORK',
        url: 'saveFn',
        params
      });

      if (status) {
        this.$message({
          message: this.id ? '修改成功' : '添加成功',
          type: 'success'
        });
        // reset form
        this.$refs['ref'].$refs['ruleForm'].resetFields();
        this.$emit('refresh');
        this.clearForm();
        this.dialogVisible = false;
        this.$emit('close');
      }
      else {
        this.$message({
          message: this.id ? '修改失败' : '添加失败',
          type: 'info'
        });
      }
    },
    async getDetail() {
      this.loading = true;
      const { bean } = await this.$services.post({
        type: 'TIMEWORK',
        url: 'getDetail',
        params: { id: this.id }
      });
      this.originData = this.$utils.deepCopy(bean);

      this.formData = bean;

      this.loading = false;
    },
    handelForm(data) {
      // 新增的情况下
      if (!this.id) {
        data.createDate = this.$datePipe(new Date());
        data.userCode = this.userInfor.id;
        data.userName = this.userInfor.userName;
        data.depName = this.userInfor.departName;
        data.depCode = this.userInfor.depCode;
      }

      return data;
    },
    submit() {
      let child = this.$refs['ref'].$refs['ruleForm'];
      child.validate(valid => {
        if (valid) {
          console.warn('submit!');
          let param = this.handelForm(this.formData);
          this.saveFn(param);
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    clearForm() {
      this.formData = {
        taskName: '',
        taskType: 'system',
        state: '-1',
        runClass: '',
        taskTimer: '',
        remark: '',
        createDate: '',
        userName: '',
        depName: '',
        depCode: ''
      };
    },
    handleClose() {
      if (this.dialogType === 'update' && this.$utils.targetIsChange(this.originData, this.handelForm(this.formData))) {
        this.$confirm('是否不保存离开', '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.clearForm();
            this.dialogVisible = false;
            this.$emit('close');
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消关闭'
            });
          });
      }
      else {
        this.clearForm();
        this.dialogVisible = false;
        this.$emit('close');
      }
    }
  },
  // dialog show
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
        if (this.id) {
          this.getDetail();
        }
      }
      else {
        this.dialogVisible = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
